import { usePollContext } from '../../../../../Context';
import usePublishedPollRemainingTime from '../../../../usePublishedPollRemainingTime';
import { getCanSeeAutoPollOverlay } from './helpers';

const useAutoPollOverlay = () => {
  const { poll } = usePollContext();

  const { remainingTimeInSeconds, remainingTimeReadable, remainingPercentage } =
    usePublishedPollRemainingTime();

  const canSeeOverlay = getCanSeeAutoPollOverlay(poll);

  return { canSeeOverlay, remainingTimeInSeconds, remainingTimeReadable, remainingPercentage };
};

export default useAutoPollOverlay;
